/* eslint-disable no-console */

const validateByType = (type, val) => {
  // console.log(`${type}, ${val}`);
  let status;
  switch (type) {
    case 'text':
      status = val !== '';
      break;
    case 'phone':
      status = new RegExp(/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/).test(val);
      break;
    case 'zipcode':
      status = new RegExp(/(^\d{5}(-\d{4})?$)|(^[ABCEGHJKLMNPRSTVXY]{1}\d{1}[A-Z]{1} *\d{1}[A-Z]{1}\d{1}$)/).test(val);
      break;
    case 'email':
      /* eslint-disable no-useless-escape */
      status = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/).test(val);
      /* eslint-enable no-useless-escape */
      break;
    default:
      break;
  }
  return status;
};

// Format phone as xxx xxx xxxx
const formatPhone = (s) => {
  if (s !== null && s !== undefined && s !== '') {
    if (s.match(new RegExp(/\d/g) || []) !== null) {
      const arr = s.match(new RegExp(/\d/g) || []).join('');
      return `${arr.substring(0, 3)} ${arr.substring(3, 6)} ${arr.substring(6)}`;
    }
    return s;
  }
  return s;
};

const validate = (form) => {
  // Identify all fields with a validate attribute in form (will be on the label for the input/submit)
  const fieldList = form.querySelectorAll('[validate]');
  let field;
  let isValid;
  let required;
  let isFormValid = true;
  let errorDiv = null;
  for (let i = 0; i < fieldList.length; i++) { /* eslint-disable-line no-plusplus */
    field = fieldList[i];
    isValid = true;
    required = field.getAttribute('required') !== null;
    // If value is required, run against validation OR
    if (required) {
      isValid = validateByType(field.getAttribute('validate'), field.value);
    }
    // If value isn't required but value has been entered that requires validation, then run
    if (!required && field.value !== '' && field.getAttribute('validate') !== 'text') {
      isValid = validateByType(field.getAttribute('validate'), field.value);
    }
    // Mark form as invalid
    errorDiv = form.querySelector(`[for="${field.id}"] ~ .form-error-label`);
    if (!isValid && errorDiv) {
      isFormValid = isValid;
      // Toggle error class on element label
      errorDiv.classList.add('field-validation-error');
    } else if (isValid && errorDiv) {
      errorDiv.classList.remove('field-validation-error');
    }
  }
  return isFormValid;
};

const disableFormSubmit = (form) => {
  if (!form) return;
  const submitBtn = form.querySelector('[type=submit]');
  if (!submitBtn) return;
  submitBtn.disabled = true;
  submitBtn.classList.add('updating');
};

const enableFormSubmit = (form) => {
  if (!form) return;
  const submitBtn = form.querySelector('[type=submit]');
  if (!submitBtn) return;
  submitBtn.disabled = false;
  submitBtn.classList.remove('updating');
};

const init = () => {};

/* eslint-enable no-console */

export {
  disableFormSubmit,
  enableFormSubmit,
  init,
  validate,
  formatPhone,
};
